import blankshield from 'blankshield';

class BlankShield {
  init(): void {
    document.addEventListener('click', event => {
      if (event.target instanceof HTMLAnchorElement && event.target.matches('[href][target=_blank]')) {
        blankshield.open(event.target.href);
        event.preventDefault();
      }
    });
  }
}

export const blankShield = new BlankShield();
